<template>
  <NotFoundText />
</template>

<script>
import NotFoundText from "@/components/common/NotFoundText.vue";
export default {
  name: "NotFound",
  components: {NotFoundText}
}
</script>
